import { stringEnum } from 'app/config/utils';

export enum DelegatedTokenType {
  BEARER             = 'Bearer',
  AUTHORIZATION_CODE = 'authorization_code',
}

export const DelegatedTokenTypeType =
  stringEnum<DelegatedTokenType>(DelegatedTokenType, 'DelegatedTokenType');

export enum LoginIntent {
  Register = 'register',
  Login    = 'login',
}

export const LoginIntentType = stringEnum<LoginIntent>(LoginIntent, 'LoginIntent');
export enum Action {
  AUTH        = 'Auth',
  ATTACH      = 'Attach',
  DMM_LOGIN   = 'DmmLogin',
  IKNOW_LOGIN = 'IknowLogin',
}
